import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire d'ajout d'une dérogation tarifaire
 * (`POST /MerchantFeeOverrides/add`).
 */
export const createFeeOverrideSchema = () =>
  z.object({
    merchantId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    productCode: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    feeRuleId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
  });

export type FeeOverrideFormValues = z.infer<
  ReturnType<typeof createFeeOverrideSchema>
>;
